'use client';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
/**
 * Используя ReadableStream рекурсивно читает части ответа, получаемого в виде потока байт.
 * Вызывает `onDownloadProgress` для каждого загруженного чанка.
 * */ const watchDownloadStream = (response, onDownloadProgress)=>{
    const totalBytes = Number(response.headers.get('content-length')) || 0;
    let transferredBytes = 0;
    if (response.status === 204) {
        if (onDownloadProgress) {
            onDownloadProgress({
                totalBytes,
                transferredBytes
            }, new Uint8Array());
        }
        return new globalThis.Response(null, {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
    const stream = new globalThis.ReadableStream({
        start (controller) {
            return _async_to_generator(function*() {
                const reader = response.body.getReader();
                if (onDownloadProgress) {
                    onDownloadProgress({
                        transferredBytes: 0,
                        totalBytes
                    }, new Uint8Array());
                }
                // Рекурсивно запрашиваем части данных, пока не получим всё.
                const read = /*#__PURE__*/ _async_to_generator(function*() {
                    const { done, value } = yield reader.read();
                    if (done) {
                        controller.close();
                        return;
                    }
                    if (onDownloadProgress) {
                        transferredBytes += value.byteLength;
                        onDownloadProgress({
                            transferredBytes,
                            totalBytes
                        }, value);
                    }
                    controller.enqueue(value);
                    yield read();
                });
                yield read();
            })();
        }
    });
    return new globalThis.Response(stream, {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers
    });
};

export { watchDownloadStream };
//# sourceMappingURL=watchDownloadStream.js.map
